import { de } from './de_DE'
import { en } from './en_EN'

export const resources = { de, en }